import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { UserSelector } from '@ui/UserSelector';

import { coreActions, ResponsibilityType, SonarObjectUser } from '@sonar-software/sonar-core';
import { useAction, useOnMount, useSonarObjectReference } from '@hooks';

export interface SonarObjectOwnerProps {
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	isSpreadsheet?: boolean;
	sonarObjectId: number;
	withLatest?: boolean;
}

export const SonarObjectOwner: React.FC<SonarObjectOwnerProps> = ({
	getPopupContainer,
	isSpreadsheet,
	sonarObjectId,
	withLatest
}) => {
	const users = useSonarObjectReference(sonarObjectId)?.users ?? [];

	const getBusinessContextOwner = useAction(coreActions.requestGetCoreSonarObjectsUsers);
	const updateBusinessContextOwner = useAction(coreActions.requestPutCoreSonarObjectsUsers);

	useOnMount(() => {
		if (withLatest) {
			getBusinessContextOwner({ sonarObjectId });
		}
	});

	const handleChange = (userId: number | undefined) => {
		const newUsers: SonarObjectUser[] = [];

		if (userId) {
			newUsers.push({
				responsibilityType: ResponsibilityType.Owner,
				userId
			});
		}

		updateBusinessContextOwner({
			sonarObjectId,
			users: newUsers
		});
	};

	const owner = users.find((user) => user.responsibilityType === ResponsibilityType.Owner);

	return (
		<UserSelector
			allowClear
			avatar
			getPopupContainer={ getPopupContainer }
			isSpreadsheet={ isSpreadsheet }
			onSingleChange={ handleChange }
			placeholder={ PLACEHOLDERS_COPY.ADD_OWNER }
			value={ owner?.userId } />
	);
};
